import { useEffect } from "react";
import PropTypes from "prop-types";
import { Form, FulfillmentAndLocationsInput } from "top-component-library";

// Mirrors add-order-rate-limit-dialog.html's inputThrottleConditions step. Reuses the same
// fulfillment-methods/locations checkbox pair (with its own "toggle all" buttons) already
// shipped for Service Charges, rather than re-implementing that cross-filtering here.
const OrderRateLimitConditionsStep = ({
  locations,
  fulfillmentMethods,
  fulfillmentMethodKeys,
  locationIds,
  onChange,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue({ fulfillment_methods: fulfillmentMethodKeys, locations: locationIds });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Form form={form} initialValues={{ fulfillment_methods: fulfillmentMethodKeys, locations: locationIds }}>
      <FulfillmentAndLocationsInput
        id="throttle-conditions"
        locations={locations}
        fulfillmentMethods={fulfillmentMethods}
        initialFulfillments={fulfillmentMethodKeys}
        form={form}
        onChange={onChange}
        fulfillmentLabel="Fulfillment Methods:"
        locationsLabel="Locations:"
      />
    </Form>
  );
};

OrderRateLimitConditionsStep.propTypes = {
  locations: PropTypes.arrayOf(PropTypes.shape({ locationId: PropTypes.string, locationName: PropTypes.string }))
    .isRequired,
  fulfillmentMethods: PropTypes.objectOf(PropTypes.string).isRequired,
  fulfillmentMethodKeys: PropTypes.arrayOf(PropTypes.string).isRequired,
  locationIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default OrderRateLimitConditionsStep;
